import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminNews = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.NEWS.GET_ALL, { params });
    return response.data;
};

export const getAdminNewsById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.NEWS.GET_BY_ID(id));
    return response.data;
};

export const createNews = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.NEWS.CREATE, data);
    return response.data;
};

export const updateNews = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.NEWS.UPDATE(id), data);
    return response.data;
};

export const deleteNews = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.NEWS.DELETE(id));
    return response.data;
};

